import { render, staticRenderFns } from "./ImageBubble.vue?vue&type=template&id=674f83bd&scoped=true&"
import script from "./ImageBubble.vue?vue&type=script&lang=js&"
export * from "./ImageBubble.vue?vue&type=script&lang=js&"
import style0 from "./ImageBubble.vue?vue&type=style&index=0&id=674f83bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674f83bd",
  null
  
)

export default component.exports